import { SelectionModel } from "@angular/cdk/collections";
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { fromEvent, merge, of, Subject, Subscription } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fuseAnimations } from "@fuse/animations";
import { FacturaDTO } from "app/main/apps/shared/interfaces/factura.interface";

import {
    catchError,
    filter,
    map,
    switchMap,
    takeUntil,
    tap,
} from "rxjs/operators";
import { OnDestroy } from "@angular/core";
import { FacturaService } from "app/main/apps/shared/services/rest/factura.service";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

import { PageFacturaDTO } from "app/main/apps/shared/interfaces/page-factura.interface";

@Component({
    selector: "app-tabla-facturas",
    templateUrl: "./tabla-facturas.component.html",
    styleUrls: ["./tabla-facturas.component.scss"],
    animations: fuseAnimations,
})
export class TablaFacturasComponent implements OnInit, OnDestroy {
    facturaMismoCliente: boolean;
    resultsLength = 0;

    @Input() facturas: FacturaDTO[];
    @Input() totalRegistros: number;

    @Output() buscarMas: EventEmitter<void> = new EventEmitter();

    dataSource: MatTableDataSource<any>;
    displayedColumns = [
        "numero",
        "estado",
        "cliente.nrRut",
        "cliente.nombre",
        "fecha",
        "montoBrutoClp",
    ];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild("filter", { static: true })
    filter: ElementRef;

    private _unsubscribeAll: Subject<any>;
    subscripciones: Subscription;
    constructor(
        private _facturaSrvc: FacturaService,
        private _fuseProgressBarService: FuseProgressBarService
    ) {
        this.facturaMismoCliente = true;
        this.subscripciones = new Subscription();
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource(this.facturas);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.subscripciones.add(
            this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0))
        );

        setTimeout(() => {
            this.tableChange();
        });
    }

    tableChange() {
        this.resultsLength = this.totalRegistros;
        merge(
            this.sort.sortChange.pipe(
                tap((data) => console.log("refreh sort"))
            ),
            this.paginator.page.pipe(
                tap((data) => console.log("refreh paginator"))
            ),
            this._facturaSrvc.facturasRefresh$.pipe(
                tap((data) => console.log("refresh!", data)),
                filter(
                    (refresh) => refresh //filtro para ordenesCompraRefresh$, merge se activa solo si el valor emitido es true, para evitar dobles llamadas
                )
            )
        )
            .pipe(
                // startWith({}),
                takeUntil(this._unsubscribeAll),

                switchMap((filtros) => {
                    //console.log(filtros);
                    this._fuseProgressBarService.show();
                    this._facturaSrvc.setPaginaActual(this.paginator.pageIndex);
                    this._facturaSrvc.setCantidaResultadosPorPagina(
                        this.paginator.pageSize
                    );
                    this._facturaSrvc.setCampoOrden(this.sort.active);
                    this._facturaSrvc.setOrden(this.sort.direction);

                    this.buscarMas.emit();
                    //return this.buscar();
                    return this._facturaSrvc.facturasChanged$;
                }),
                map((data: PageFacturaDTO) => {
                    // Flip flag to show that loading has finished.
                    this._fuseProgressBarService.hide();
                    this.resultsLength = data.totalElements;
                    /*    this._facturaSrvc.setTotalDeResultados(
                        data.totalElements
                    );*/

                    return data.content;
                }),
                catchError(() => {
                    this._fuseProgressBarService.hide();
                    // Catch if the GitHub API has reached its rate limit. Return empty data.

                    return of([]);
                })
            )
            .subscribe((data: FacturaDTO[]) => {
                this._fuseProgressBarService.hide();
                this.facturas = data;
                this.dataSource = new MatTableDataSource(this.facturas);
            });
        //);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
